import axios from "axios";

const state = {
  adminKitsV2: null,
  adminReportV2: null,
  testKitInfoV2: null,
  userInfoV2: null,
  paginationV2: null,
  paginationPageV2: null,
  kitsSubTotalV2: 0,
  completedKitCountV2: 0,
  searchstrV2: null,
  statusV2: "",
  sortedByV2: "desc",
  orderByV2: "shipped_at",
  dateFromV2: null,
  dateToV2: null,
  paymentV2: "paid",
  daysV2: 30,
  kitStatusV2: null,
  loaderV2: false,
  errorMessageV2: false,
  timelineStatusV2: {},
  componentNumV2: 0,
  overDuesV2: {},
  kitAvgV2: {},
  hasFilterV2: false,
  outlierV2: null
};

const mutations = {
  setAdminKitsV2(state, array) {
    state.adminKitsV2 = array;
  },
  setAdminReportV2(state, report) {
    state.adminReportV2 = report;
  },
  setTestKitInfoV2(state, obj) {
    state.testKitInfoV2 = obj;
  },
  setUserInfoV2(state, obj) {
    state.userInfoV2 = obj;
  },
  setPaginationV2(state, obj) {
    state.paginationV2 = obj;
  },
  setPaginationPageV2(state, num) {
    state.paginationPageV2 = num;
  },
  setKitsSubTotalV2(state, data) {
    state.kitsSubTotalV2 = data;
  },
  setCompletedKitCountV2(state, data) {
    state.completedKitCountV2 = data;
  },
  setSearchstrV2(state, str) {
    state.searchstrV2 = str;
  },
  setStatusFilterV2(state, array) {
    state.statusV2 = array.join();
  },
  setSortedByV2(state, data) {
    state.sortedByV2 = data;
  },
  setOrderByV2(state, data) {
    state.orderByV2 = data;
  },
  setDateFromV2(state, date) {
    state.dateFromV2 = date;
  },
  setDateToV2(state, date) {
    state.dateToV2 = date;
  },
  setPaymentFilterV2(state, str) {
    state.paymentV2 = str;
  },
  setDaysFilterV2(state, data) {
    state.daysV2 = data;
  },
  setKitStatusV2(state, data) {
    state.kitStatusV2 = data;
  },
  setLoaderV2(state, data) {
    state.loaderV2 = data;
  },
  setErrorMessageV2(state, data) {
    state.errorMessageV2 = data;
  },
  setTimelineStatusV2(state, data) {
    state.timelineStatusV2 = data;
  },
  setComponentNumV2(state, data) {
    state.componentNumV2 = data;
  },
  setOverDuesV2(state, data) {
    state.overDuesV2 = data;
  },
  setKitAvgV2(state, data) {
    state.kitAvgV2 = data;
  },
  setHasFilterV2(state, data) {
    state.hasFilterV2 = data;
  },
  setOutlierV2(state, data) {
    state.outlierV2 = data;
  }
};

const actions = {
  sendSearchReqV2({ commit }) {
    let url = "per_page=20";

    if (state.searchstrV2 !== null) {
      url += `&search=${state.searchstrV2}`;
    }
    if (state.orderByV2 !== null && state.sortedByV2 !== null) {
      url += `&order_by=${state.orderByV2}&sorted_by=${state.sortedByV2}`;
    }
    if (state.statusV2 !== "") {
      url += `&status=${state.statusV2}`;
    }
    if (state.paymentV2 !== "") {
      url += `&payment=${state.paymentV2}`;
    }
    if (state.paginationPageV2 !== null) {
      url += `&page=${state.paginationPageV2}`;
    }
    if (state.dateFromV2 !== null) {
      url += `&date_from=${state.dateFromV2}`;
    }
    if (state.dateToV2 !== null) {
      url += `&date_to=${state.dateToV2}`;
    }
    if (state.daysV2 !== null) {
      url += `&days=${state.daysV2}`;
    }
    if (state.outlierV2 !== null && state.outlierV2 !== "") {
      url += `&outlier=${state.outlierV2}`;
    }

    commit("setLoaderV2", true);
    return axios.get(`/v1/admin/kitsv2?${url}`).then(res => {
      commit("setLoaderV2", false);
      commit("setAdminKitsV2", res.data.data.kitsV2.data);
      commit("setPaginationV2", res.data.data.kitsV2.lastPage);
      commit("setCompletedKitCountV2", res.data.data.total);
      commit("setKitsSubTotalV2", res.data.data.sub_total_count);
      commit("setKitStatusV2", res.data.data.kit_status);
      // Track whether narrowing filters are active (status, date range, or search)
      const hasSearch = state.searchstrV2 !== null && state.searchstrV2 !== "" && state.searchstrV2 !== "undefined";
      commit("setHasFilterV2", !!(res.data.data.has_filter || hasSearch));
    }).catch(() => {
      commit("setLoaderV2", false);
      commit("setErrorMessageV2", true);
    });
  },

  getAdminInfoV2({ commit, dispatch }) {
    dispatch("sendSearchReqV2");
    dispatch("overDuesV2");
    const data = {
      payment: state.paymentV2,
      day: state.daysV2
    };
    return axios.post("/v1/admin/kitsv2/dashboard", data).then(res => {
      commit("setAdminReportV2", res.data.data.report);
      commit("setTimelineStatusV2", res.data.data.report);
    });
  },

  refreshKitsV2({ commit, dispatch }) {
    return axios.get("/v1/admin/kitsv2/refresh").then(() => {
      // After refresh completes, re-fetch dashboard and overdue data
      dispatch("getAdminInfoV2");
    });
  },

  overDuesV2({ commit }) {
    const data = {
      payment: state.paymentV2,
      day: state.daysV2
    };
    return axios.post("/v1/admin/kitsv2/overdues", data).then(res => {
      commit("setOverDuesV2", res.data.data.count);
      if (res.data.data.averages) {
        commit("setKitAvgV2", res.data.data.averages);
      }
    });
  },

  testKitInfoV2({ commit }, id) {
    return axios.get(`/v1/admin/kitsv2/${id}`).then(res => {
      commit("setTestKitInfoV2", res.data.data.kit);
    });
  },

  getUserInfoV2({ commit }, id) {
    return axios.get(`/v1/admin/users/${id}`).then(res => {
      commit("setUserInfoV2", res.data.data.user);
    });
  },

  addTestKitV2({ commit }, data) {
    return axios.post("/v1/admin/kitsv2", data).then(res => {
      return res.data.data.kit;
    });
  },

  kitexistV2(_, data) {
    return axios.post("/v1/admin/kitsv2/kitexist", data).then(res => {
      return res;
    });
  },

  sendNewDataV2({ commit, dispatch }, data) {
    return axios.put(`/v1/admin/kitsv2/${data.id}`, data.data).then(res => {
      commit("setTestKitInfoV2", res.data.data.kit);
      dispatch("sendSearchReqV2");
      return res.data.data.kit;
    });
  },

  editTestKitV2({ commit, dispatch }, data) {
    return axios.put(`/v1/admin/kitsv2edit/${data.id}`, data.data).then(res => {
      commit("setTestKitInfoV2", res.data.data.kit);
      dispatch("sendSearchReqV2");
      return res.data.data.kit;
    });
  },

  archiveKitV2({ dispatch }, data) {
    return axios.post("/v1/admin/kitsv2/archive", data).then(res => {
      dispatch("sendSearchReqV2");
      return res;
    });
  },

  unArchiveKitV2({ dispatch }, data) {
    return axios.post("/v1/admin/kitsv2/unarchive", data).then(res => {
      dispatch("sendSearchReqV2");
      return res;
    });
  },

  deleteKitV2({ dispatch }, id) {
    return axios.delete(`/v1/admin/kitsv2/${id}`).then(res => {
      dispatch("sendSearchReqV2");
      return res;
    });
  },

  resetKitV2({ commit, dispatch }, data) {
    return axios.put(`/v1/admin/kitsv2/${data.id}`, { status: 0 }).then(res => {
      commit("setTestKitInfoV2", res.data.data.kit);
      dispatch("sendSearchReqV2");
      return res.data.data.kit;
    });
  },

  resendNotificationV2(_, data) {
    return axios.post(
      `/v1/admin/kitsv2/${data.kit_id}/resend/latest_notification`,
      data.data || {}
    );
  },

  getKitLogV2({ commit }, kitId) {
    return axios
      .get(`/v1/admin/kitsv2log?kit_id=${kitId}`)
      .then(res => {
        // Reuses the V1 `setkitLog` mutation + `getkitLogData` getter so the
        // existing DisplayLog.vue renders V2 entries with no branching.
        commit("setkitLog", res.data.data.query, { root: true });
      });
  },

  saveUserSubmitedV2({ commit }, data) {
    return axios.post(`/v1/admin/saveUserSubmitedV2`, data).then(res => {
      // V1 parity: refresh both kit + user info in the modal after save so the
      // sidebar and detail panel reflect the new state immediately.
      commit("setTestKitInfoV2", res.data.data.testkit);
      commit("setUserInfoV2", res.data.data.user);
      return res.data.data;
    });
  },

  setSearchstrV2({ commit }, data) {
    commit("setSearchstrV2", data);
  },

  setSortedByV2({ commit }, data) {
    commit("setSortedByV2", data);
    return Promise.resolve();
  },

  setOrderByV2({ commit }, data) {
    commit("setOrderByV2", data);
    return Promise.resolve();
  },

  setPaginationPageV2({ commit }, data) {
    commit("setPaginationPageV2", data);
    return Promise.resolve();
  },

  setDateFromV2({ commit }, data) {
    commit("setDateFromV2", data);
    commit("setPaginationPageV2", null);
  },

  setDateToV2({ commit }, data) {
    commit("setDateToV2", data);
    commit("setPaginationPageV2", null);
  },

  setStatusFilterV2({ commit }, data) {
    commit("setStatusFilterV2", data);
    commit("setPaginationPageV2", null);
  },

  setPaymentFilterV2({ commit }, data) {
    commit("setPaymentFilterV2", data);
    commit("setPaginationPageV2", null);
  },

  setDaysFilterV2({ commit }, data) {
    commit("setDaysFilterV2", data);
    commit("setPaginationPageV2", null);
  },

  setComponentNumV2({ commit }, data) {
    commit("setComponentNumV2", data);
  },

  setOutlierV2({ commit }, data) {
    commit("setOutlierV2", data);
    commit("setPaginationPageV2", null);
  },

  setLoaderV2({ commit }, data) {
    commit("setLoaderV2", data);
  },

  setErrorMessageV2({ commit }, data) {
    commit("setErrorMessageV2", data);
  },

  clearInfoV2({ commit }) {
    commit("setTestKitInfoV2", null);
    commit("setUserInfoV2", null);
  },

  sendSearchReqLabV2(_, searchStr) {
    return axios.get(`/v1/admin/kitsv2Labs?search=${searchStr}`).then(res => {
      return res.data.data;
    });
  },

  resetStateV2({ commit }) {
    commit("setSearchstrV2", null);
    commit("setOrderByV2", "shipped_at");
    commit("setSortedByV2", "desc");
    commit("setStatusFilterV2", []);
    commit("setDateFromV2", null);
    commit("setDateToV2", null);
    commit("setPaymentFilterV2", "paid");
    commit("setDaysFilterV2", 30);
    commit("setPaginationPageV2", null);
    commit("setErrorMessageV2", false);
    commit("setComponentNumV2", 0);
    commit("setHasFilterV2", false);
    commit("setOutlierV2", null);
  }
};

const getters = {
  getAdminKitsV2: (state) => state.adminKitsV2,
  adminReportV2: (state) => state.adminReportV2,
  paginationV2: (state) => state.paginationV2,
  kitsSubTotalV2: (state) => state.kitsSubTotalV2,
  completedKitCountV2: (state) => state.completedKitCountV2,
  getTestKitInfoV2: (state) => state.testKitInfoV2,
  getUserInfoV2: (state) => state.userInfoV2,
  getLoaderV2: (state) => state.loaderV2,
  getErrorMessageV2: (state) => state.errorMessageV2,
  getTimelineStatusV2: (state) => state.timelineStatusV2,
  getKitStatusV2: (state) => state.kitStatusV2,
  getComponentNumV2: (state) => state.componentNumV2,
  getSearchstrV2: (state) => state.searchstrV2,
  getOverDuesV2: (state) => state.overDuesV2,
  getKitAvgV2: (state) => state.kitAvgV2,
  getHasFilterV2: (state) => state.hasFilterV2
};

export default {
  state,
  mutations,
  actions,
  getters
};
